import {getUserRequests} from '@/helpers/api/userrequests'
const listingColumns = localStorage.getItem('user_request_columns')

const messagesStore = {
  namespaced: true,
  state: {
		listingColumns: listingColumns ? JSON.parse(listingColumns):{
			client: true,
			project: true,
			status: true,
			created: true,
			actions: true
		},
		companyUserRequests: [],
		companyUserRequestsCount: 0,
		companyUserRequestsLastId: null,
		loadingCompanyUserRequests: false,
		reportComponentModalId: [],
		newRequestModal: false,
		newRequestModalInfo: null,
		userRequestModalId: null,
		userRequestModalInfo: null
  },
  mutations: {
    setListingColumns(state, listingColumns) {
      state.listingColumns = listingColumns
			localStorage.setItem('user_request_columns', JSON.stringify(listingColumns))
    },
		setLoadingCompanyUserRequests(state, value){
			state.loadingCompanyUserRequests = value
		},
		setCompanyUserRequests(state, value){
			state.companyUserRequests = value
		},
    setCompanyUserRequestsLastId(state, contract_id) {
      state.companyUserRequestsLastId = contract_id
    },
		setCompanyUserRequestsCount(state, value){
			state.companyUserRequestsCount = value
		},
		setNewRequestModal(state, value){
			state.newRequestModal = value
		},
		setNewRequestModalInfo(state, value){
			state.newRequestModalInfo = value
		},
		setUserRequestModalId(state, value){
			state.userRequestModalId = value
		},
		setUserRequestModalInfo(state, value){
			state.userRequestModalInfo = value
		},
  },
  actions: {
    async getCompanyUserRequests({ commit }, {search = null, start = 0, limit = 20} = {}) {
      commit('setLoadingCompanyUserRequests', true)
      const data = {
				search,
        start,
        limit
      }
      const reports = await getUserRequests(data)
      if (reports.code === 200) {
        commit('setCompanyUserRequests', reports.user_requests)
        commit('setCompanyUserRequestsLastId', reports.last_user_request_id)
				commit('setCompanyUserRequestsCount', reports.user_requests_count)
      }
      commit('setLoadingCompanyUserRequests', false)
    },
  }
}

export default messagesStore
